<template>
<div>
    <div class="container flash-message-top-container">
      <flash-message class="flash-message-top"></flash-message>
    </div> 
    <div class="container text-center container-admin">
    <h3>{{title}}</h3>
    <form>
      <div class="form-group row">
        <div class="col-md-6 label-left">
           <label for="txtOpenHours">Open hours</label>
           <input type="text" class="form-control" id="txtOpenHours" aria-describedby="emailHelp" placeholder="Open hours" v-model="SiteConfig.open_hours">    
        </div>
        <div class="col-md-6 label-left">
           <label for="txtTelephone">Telephon</label>
           <input type="text" class="form-control" id="txtTelephone" aria-describedby="emailHelp" placeholder="Telephone" v-model="SiteConfig.top_phone">    
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6 label-left">
           <label for="txtOpenHours">Contact email address</label>
           <input type="email" class="form-control" id="txtContactEmail" aria-describedby="emailHelp" placeholder="Contact email address" v-model="SiteConfig.contact_email">    
        </div>
        <div class="col-md-6 label-left">
           <Language />
        </div>
      </div>
       <div class="form-group row">
        <div class="col-md-12 label-left">
           <label for="txtOpenHours">Site Title</label>
           <input type="text" class="form-control" id="txtSiteTitle" aria-describedby="siteTitle" placeholder="site title" v-model="SiteConfig.site_title">    
        </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12 label-left">
            <label for="txtOpenHours">Site Description</label>
            <textarea class="form-control" id="txtSiteDescription" style="resize: none;" rows="3" v-model="SiteConfig.site_description"></textarea>
          </div>
        </div>
        <div class="form-group row">
        <div class="col-md-12 label-left">
           <label for="txtOpenHours">Site Keywords</label>
           <textarea class="form-control" id="txtSiteDescription" style="resize: none;" rows="3" v-model="SiteConfig.site_keywords"></textarea>  
        </div>
        </div>
      
      <button type="bottom" class="btn btn-primary" @click="(e) => saveSiteConfiguration(e)">Save configuration</button>
    </form>
  </div>
</div>
</template>

<script>
  import { getDataFromServer } from "../../utils/DataProvider";
  import Language from "../partial/Language"
  export default {  
    data: () => {
      return{
         title: 'Site config',
         SiteConfig: {_id: '', open_hours: '', top_phone: '', contact_email: '',language: '',site_title:'',site_description:'',site_keywords:''},
      }     
    },    
    components: {       
       Language,
    },
    methods: {
      changeLanguage(e){          
          this.SiteConfig.language = e.target.value
      },

      saveSiteConfiguration(e){
        e.preventDefault();       
        getDataFromServer('update_configuration', this.SiteConfig)
        .then(data => 
        {
          if(data.data.success === true){              
            this.flash('save site configuration success ' , 'success', {timeout: 4000})
            this.$store.dispatch('SET_CURRENT_LANGUAGE', this.SiteConfig.language)                             
          }
          else{
            this.flash('save site configuration error: ' + obj.data.text , 'error', {timeout: 4500})
          }   
        })
        .catch(err => {          
          this.flash('save site configuration error: ' + err, 'error', {timeout: 4500})
        })
      },

      getSiteConfiguration(){
        getDataFromServer('get_configuration', null)
        .then(obj => 
        {          
          if(obj.data.success === true){                          
            this.SiteConfig=obj.data.data;         
           
            //init language
            var languageObj = {
              name: 'language', 
              label: 'Language',               
              selected: this.SiteConfig.language,
              onSelectCB: this.changeLanguage, 
            }              
            this.$store.dispatch('INIT_LANGUAGE_ENTITY', languageObj);
          }
          else{
            this.flash('get site configuration error: ' + obj.data.text , 'error', {timeout: 4500})
          }          
        })
        .catch(err => {
          this.flash('get site configuration error: ' + err, 'error', {timeout: 4500})
        })
      }
    },
    created() {
      this.getSiteConfiguration()
    },
  }
</script>

<style>  
</style>
